import {put, takeEvery, call} from 'redux-saga/effects';
import {
    LOCK_PERIOD_ACTION_REQUEST,
    LOCK_PERIOD_ACTION_SUCCESS,
    LOCK_PERIOD_ACTION_FAILURE,
    LOCK_PERIOD_ACTION
} from '../constants';

import Api, {ApiMethods} from 'feedback-system/middleware/api';

import {
    LockPeriodRequest,
    LockPeriodSuccess,
    LockPeriodFailure,
    LockPeriodAction
} from '../typedef';

type IActions = LockPeriodRequest & LockPeriodSuccess & LockPeriodFailure & LockPeriodAction;

function* lockPeriod(action: IActions) {
    try {

        yield put({type: LOCK_PERIOD_ACTION_REQUEST});

        const dataPeriod = yield call(Api.fetch, {
            endpoint: `periods/lock?id=${action.id}&lockedStatus=true`,
            method: ApiMethods.PUT
        });

        yield put({
            type: LOCK_PERIOD_ACTION_SUCCESS,
            period: dataPeriod.responseData
        });
    } catch (e) {
        yield put({type: LOCK_PERIOD_ACTION_FAILURE, error: e});
    }
}

function* lockPeriodSaga() {
    yield takeEvery(LOCK_PERIOD_ACTION, lockPeriod);
}

export {
    lockPeriodSaga
};
